import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findEngineeringOrderList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v2/customer_remind/list?` + params,
        method: 'GET'
    })
}

export const downloadExcelV2 = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v2/customer_remind/excel?` + params,
        method: 'GET'
    })
}


export const changeStatus = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v2/customer_remind/changeStatus?` + params,
        method: 'POST',
    })
}
export const closeStatus = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v2/customer_remind/close?` + params,
        method: 'POST',
    })
}
export const findTemplateV2 = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sms/v1/template/selectV2?` + params,
        method: 'GET'
    })
}
export const findUsersAll = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUsersAll?` + params,
        method: 'GET'
    })
}
export const findStuff = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/choose?` + params,
        method: 'GET'
    })
}




export const findProject = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/project/select?` + params,
        method: 'GET'
    })
}
export const findEngineeringProjectAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-project/all`,
        method: 'GET'
    })
}
export const editEngineeringOrder = (id, params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/engineeringOrder/${id}`,
        method: 'PUT',
        data: params
    })
}
export const findEngineeringProjectId = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-project/children/${id}`,
        method: 'GET'
    })
}

export const findUsersByUserTypeAll = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUsersAll?` + params,
        method: 'GET'
    })
}
export const addEngineeringOrder = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/engineeringOrder`,
        method: 'POST',
        data: params
    })
}
export const editAllEngineeringOrder = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/engineeringOrder`,
        method: 'PUT',
        data: params
    })
}
export const findEngineeringOrderById = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/work-order/findEngineeringOrderById/${id}`,
        method: 'GET'
    })
}
export const passAudit = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/pass`,
        method: 'PUT',
        data: data
    })
}
export const refusedAudit = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/refused`,
        method: 'PUT',
        data: data
    })
}
export const balancePay = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/balancePay`,
        method: 'PUT',
        data: data
    })
}












export const findGuaranteeDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/guarantee/${id}`,
        method: 'GET'
    })
}


export const delItem = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-work/v2/guarantee/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}